import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием компании клиента
export const CompanyClient = createSlice({
    // имя слайса, используется для идентификации в Redux
    name: "companyclient",
    // начальное состояние слайса
    initialState: {
        name:'',
        inn:''
    },
    // редьюсеры для изменения состояния
    reducers: {
        onChangeCompanyClient: (state, {payload}) => {
            state.name = payload.name;
            state.inn = payload.inn;
            return state;
        },
    },

});

// экспортируем действия для изменения состояния
export const { onChangeCompanyClient } = CompanyClient.actions;
export const companyClientSelector = (state) => state.companyclient;